import React, { useState, useEffect } from 'react';
import ImpdsDetails from './ImpdsDetails';
import { CircularProgress } from '@mui/material';

const ImpdsStateIn = ({ month, year, homeState, transName, transComm, onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [detailsData, setDetailsData] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, [month, year, homeState, transName, transComm]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_URL_SIDE}/api/impds/state-in?month=${month}&year=${year}&homeState=${homeState}&status=I&transName=${transName}&transComm=${transComm}`
      );
      const result = await response.json();
      setData(result);
    } catch (error) {
      console.error('Error fetching state in data:', error);
    } finally {
      setLoading(false);
    }
  };

  const getTransDetails = async (distCode, stateCode, month, year, status) => {
    try {
      setDetailsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_URL_SIDE}/api/impds/details?status=${status}&month=${month}&year=${year}&state=${stateCode}&homeState=${homeState}&dist=${distCode}&transName=${transName}&transComm=${transComm}`
      );
      const result = await response.json();
      setDetailsData(result);
      setTimeout(() => {
        const el = document.getElementById('detailsRd');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    } catch (error) {
      console.error('Error fetching transaction details:', error);
    } finally {
      setDetailsLoading(false);
    }
  };

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20px" }}>
      <CircularProgress/>
    </div>;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  const monthNames = ["January", "February", "March", "April", "May", "June", "July",
                      "August", "September", "October", "November", "December"];
  const monthInt = parseInt(month);

  return (
    <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '40px' }}>
      <div className="tableheader" style={{ maxWidth: '900px', padding: '6px', margin: '0 auto', backgroundColor: '#1785CF', color: '#fff' }}>
        {transName} IN ONORC for the month of {monthNames[monthInt-1]}-{year}
      </div>
      <div style={{ maxWidth: '900px', overflowX: 'auto', margin: '0 auto' }}>
        <table id="fpsreport"
         style={{ width: '100%', borderCollapse: 'collapse', margin: 0, padding: 0 }}>
          {data.reportList && data.reportList.length > 0 && data.stateList && data.stateList.length > 0 ? (
            <>
              <thead>
                <tr className="tableheader">
                  <td rowSpan="2" >SL NO.</td>
                  <td rowSpan="2" >SALE DISTRICT</td>
                  <td colSpan={data.stateList.length} >HOME STATE</td>
                </tr>
                <tr className="tableheader">
                  {data.stateList.map((state, index) => (
                    <td key={index} >{state.state_name_en}</td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.reportList.map((report, index) => (
                  <tr key={index}>
                    <td style={bodyCellStyle()}>{index + 1}</td>
                    <td style={bodyCellStyle()}>{report.dist_name_en}</td>
                    {data.stateList.map((state, stateIndex) => {
                      const stateCount = report.list.find(s => s.stateCode === state.state_code);
                      const count = stateCount ? stateCount.in_count : 0;
                      return (
                        <td key={stateIndex} align="right" style={bodyCellStyle()}>
                          {count > 0 ? (
                            <a
                              style={{ cursor: 'pointer' }}
                              onClick={() => getTransDetails(report.dist_code, state.state_code, month, year, 'I')}
                            >
                              {count}
                            </a>
                          ) : (
                            count
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="tableheader">
                  <td colSpan="2" >Total</td>
                  {data.stateList.map((state, index) => {
                    const total = data.reportList.reduce((sum, report) => {
                      const stateCount = report.list.find(s => s.stateCode === state.state_code);
                      return sum + (stateCount ? stateCount.in_count : 0);
                    }, 0);
                    return (
                      <td key={index} align="right" >{total}</td>
                    );
                  })}
                </tr>
              </tfoot>
            </>
          ) : (
            <tbody>
              <tr className="tableheader">
                <td colSpan={(data.stateList ? data.stateList.length : 0) + 2} align="center" >
                  No data found
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
      <div align="center" id="loadingRd" style={{ display: detailsLoading ? 'block' : 'none', marginTop: '10px' }}>
             <CircularProgress/>
          
      </div>
      <div id="detailsRd" style={{ marginTop: '18px' }}>
        {detailsData && (
          <ImpdsDetails
            data={detailsData}
            onClose={() => setDetailsData(null)}
          />
        )}
      </div>
    </div>
  );
};

const theadCellStyle = (bg) => ({
  backgroundColor: bg,
  color: '#fff',
  padding: '6px',
  border: '1px solid #ddd'
});

const bodyCellStyle = () => ({
  padding: '6px',
  border: '1px solid #ddd'
});

const tfootCellStyle = (bg) => ({
  backgroundColor: bg,
  color: '#fff',
  padding: '6px',
  border: '1px solid #ddd'
});

export default ImpdsStateIn;


